var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { identity } from 'fp-ts/function';
import * as t from 'io-ts';
var OfType = /** @class */ (function (_super) {
    __extends(OfType, _super);
    function OfType(name) {
        var _this = _super.call(this, name !== undefined ? "Of<".concat(name, ">") : 'Of', function (_) { return true; }, function (u, c) { return t.failure(u, c, 'A proper codec must be provided'); }, identity) || this;
        _this._tag = 'OfType';
        return _this;
    }
    return OfType;
}(t.Type));
export { OfType };
/**
 * Creates a codec for a specfic type which always fails. The purpose of the
 * helper is to create models when used only in combination with, for instance,
 * `getLenses`. If validation is necessary then a proper codec with full
 * information about the structure must be used.
 *
 */
export var of = function (name) { return new OfType(name); };
